<!--
 * @Author: 冯伟绩 fengweiji@wekoi.cn
 * @Date: 2025-12-30 14:25:00
 * @LastEditors: 冯伟绩 fengweiji@wekoi.cn
 * @LastEditTime: 2026-01-06 17:25:46
 * @Description: 签到领积分按钮组件
 * @FilePath: /weryai-web/components/SignInButton.vue
-->
<template>
    <div style="z-index: 999">
        <!-- PC端签到入口按钮 -->
        <div v-if="!isMobile" class="sign-in-button-wrapper" @click="handleClick">
            <div class="sign-in-button">
                <!-- 签到领积分文字 -->
                <span class="sign-in-text">{{
                    t('menus.signInEarnCredits')
                }}</span>

                <!-- 小箭头图标 -->
                <img src="~/assets/images/common/arrow.svg" alt="arrow" class="sign-in-arrow" />

                <!-- 签到图标 -->
                <img src="~/assets/images/common/sign_in.svg" alt="sign in" class="sign-in-icon" />

                <!-- 红点提示（未签到时显示） -->
                <div v-if="showRedDot" class="sign-red-dot"></div>
            </div>
        </div>

        <!-- 移动端签到入口按钮 - 悬浮在右下角（首页不显示，因为有 MobileHomeHeader） -->
        <div v-else-if="showMobileFloatButton" class="sign-in-button-mobile-wrapper" @click="handleClick">
            <div class="sign-in-button-mobile">
                <img src="~/assets/images/common/sign_in_phone.png" alt="sign in" class="sign-in-phone-icon" />
                <!-- 红点提示（未签到时显示） -->
                <div v-if="showRedDot" class="sign-red-dot-mobile"></div>
            </div>
        </div>

        <!-- 签到弹窗 -->
        <ClientOnly>
            <!-- PC端弹窗 -->
            <el-dialog v-if="!isMobile" v-model="dialogVisible" :show-close="false" :close-on-click-modal="true"
                :close-on-press-escape="true" :lock-scroll="false" width="722px" align-center class="sign-in-dialog"
                @close="handleDialogClose">
                <!-- 弹窗内容 -->
                <div class="dialog-wrapper">
                    <!-- 右上角关闭按钮 -->
                    <button class="dialog-close-btn" @click="handleDialogClose">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.33334 3.33334L16.6667 16.6667M16.6667 3.33334L3.33334 16.6667" stroke="#FEFEFE"
                                stroke-width="2" stroke-linecap="round" />
                        </svg>
                    </button>

                    <!-- 内容区域 -->
                    <div class="dialog-content">
                        <!-- 签到模块框 -->
                        <div class="sign-in-module">
                            <!-- 头部区域 -->
                            <div class="module-header">
                                <div class="header-top">
                                    <img src="~/assets/images/common/gift_.svg" alt="gift" class="header-gift-icon" />
                                    <div class="module-title" role="heading" aria-level="2">
                                        {{ t('menus.dailySignIn') }}
                                    </div>
                                </div>
                                <p class="module-subtitle">
                                    {{ t('menus.consecutiveSignInRewards') }}
                                </p>
                            </div>

                            <!-- Day 1-7 签到卡片 -->
                            <div class="sign-cards-grid">
                                <div v-for="(
reward, index
                                    ) in signCardData?.daily_rewards || []" :key="index" class="sign-card" :class="{
                                        'show-border':
                                            reward.sign_status === 'NOT_SIGN',
                                        'is-blindbox': !reward.visible,
                                        'not-open':
                                            reward.sign_status === 'NOT_OPEN',
                                    }">
                                    <!-- 大奖角标 - 盲盒专属 -->
                                    <div v-if="!reward.visible" class="prize-badge">
                                        {{ t('menus.grandPrize') }}
                                    </div>

                                    <!-- 签到奖励区域 -->
                                    <div class="sign-card-reward">
                                        <!-- 积分奖励 -->
                                        <template v-if="
                                            reward.visible &&
                                            reward.rewards?.length > 0
                                        ">
                                            <div class="reward-bg">
                                                <img src="~/assets/images/common/sign_in_bg.svg" alt="bg"
                                                    class="reward-bg-img" />
                                            </div>
                                            <div class="reward-content">
                                                <span class="reward-amount">+{{
                                                    reward.rewards?.[0]
                                                        ?.amount
                                                }}</span>
                                            </div>
                                        </template>
                                        <!-- 盲盒奖励 -->
                                        <template v-else-if="!reward.visible">
                                            <div class="blindbox-content">
                                                <img src="~/assets/images/common/big_prize.webp" alt="prize"
                                                    class="blindbox-icon" />
                                            </div>
                                        </template>
                                    </div>

                                    <!-- 底部信息 -->
                                    <div class="sign-card-footer">
                                        <!-- 已签到显示对勾图标 -->
                                        <img v-if="
                                            reward.sign_status === 'SIGNED'
                                        " src="~/assets/images/common/yes.svg" alt="signed" class="footer-yes-icon" />
                                        <!-- 未签到显示日期 -->
                                        <span v-else class="sign-card-day">
                                            {{ t('menus.day') }}
                                            {{ reward.day }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- 领取按钮 -->
                            <button class="claim-button" :class="{
                                disabled: todaySigned || claiming,
                            }" :disabled="todaySigned || claiming" @click="handleClaim">
                                {{ claimButtonText }}
                            </button>
                        </div>

                        <!-- 邀请好友模块 -->
                        <div class="invite-module">
                            <!-- 头部区域 -->
                            <div class="invite-header">
                                <div class="invite-header-left">
                                    <svg class="invite-icon" width="18" height="18" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M15 3H21V9" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 14L21 3" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span class="invite-title">{{ t('signIn.inviteFriends') }}</span>
                                </div>
                                <div class="invite-header-right">
                                    <span class="invite-limit-badge">{{ t('signIn.todayLimit') }}: {{
                                        inviteRewards.today_valid_count
                                    }}/10</span>
                                </div>
                            </div>

                            <!-- 链接复制区域 -->
                            <div class="invite-link-box">
                                <span class="invite-link-text">{{ inviteLink || 'weryai.com/?invite_code=...' }}</span>
                                <button class="invite-copy-btn" @click="copyInviteLink">
                                    <svg class="copy-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span>{{ t('signIn.copyLink') }}</span>
                                </button>
                            </div>

                            <!-- 统计数据区域 -->
                            <div class="invite-stats-box">
                                <div class="invite-stat-item">
                                    <div class="stat-label">
                                        <svg class="stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{ t('signIn.validInvites') }}</span>
                                    </div>
                                    <div class="stat-value-row">
                                        <span class="stat-value">{{ inviteRewards.total_valid_count }}</span>
                                        <span class="stat-unit">{{ t('signIn.people') }}</span>
                                        <span class="stat-today-badge">{{ t('signIn.today') }}: {{
                                            inviteRewards.today_valid_count }}</span>
                                    </div>
                                </div>
                                <div class="invite-stat-divider"></div>
                                <div class="invite-stat-item">
                                    <div class="stat-label">
                                        <svg class="stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20 12V22H4V12" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22 7H2V12H22V7Z" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 22V7" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{ t('signIn.pending') }}</span>
                                    </div>
                                    <div class="stat-value-row">
                                        <span class="stat-value tokens">{{ inviteRewards.pending_points }}</span>
                                        <span class="stat-unit tokens">{{ t('signIn.tokens') }}</span>
                                    </div>
                                </div>
                                <button class="invite-claim-btn"
                                    :disabled="claimLoading || inviteRewards.pending_points <= 0"
                                    @click="claimInviteRewards">
                                    {{ claimLoading ? '...' : t('signIn.claimNow') }}
                                </button>
                            </div>

                            <!-- 底部规则提示框 -->
                            <div class="invite-rules-box">
                                <div class="rules-left">
                                    <div class="rules-title-row">
                                        <span class="rules-title">{{ t('signIn.forEachFriend') }}</span>
                                        <span class="rules-hot-badge">HOT</span>
                                    </div>
                                    <div class="rules-content">
                                        <div class="rules-item">
                                            <svg class="rules-warn-icon" width="14" height="14" viewBox="0 0 24 24"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.29 3.86L1.82 18C1.64 18.3 1.55 18.64 1.55 19C1.55 19.36 1.64 19.7 1.82 20C2 20.3 2.26 20.56 2.56 20.74C2.86 20.92 3.2 21.01 3.55 21H20.49C20.84 21.01 21.18 20.92 21.48 20.74C21.78 20.56 22.04 20.3 22.22 20C22.4 19.7 22.49 19.36 22.49 19C22.49 18.64 22.4 18.3 22.22 18L13.75 3.86C13.57 3.56 13.31 3.32 13 3.15C12.69 2.98 12.35 2.89 12 2.89C11.65 2.89 11.31 2.98 11 3.15C10.69 3.32 10.43 3.56 10.25 3.86H10.29Z"
                                                    stroke="#FAAD14" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M12 9V13" stroke="#FAAD14" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <circle cx="12" cy="17" r="1" fill="#FAAD14" />
                                            </svg>
                                            <span class="rules-text">{{ t('signIn.ruleText') }} <span
                                                    class="rules-highlight">{{
                                                        t('signIn.completeGeneration') }}</span> {{ t('signIn.afterReward')
                                                    }}</span>
                                        </div>
                                        <div class="rules-item">
                                            <span class="rules-limit">{{ t('signIn.dailyLimitTip') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="rules-right">
                                    <span class="rules-reward-value">+35</span>
                                    <span class="rules-reward-unit">{{ t('signIn.tokens') }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 任务中心模块 -->
                        <div class="task-module">
                            <!-- 任务中心标题 -->
                            <div class="task-header">
                                <svg class="task-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 11H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 16H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 11H8.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 16H8.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span class="task-title">{{ t('signIn.taskCenter') }}</span>
                            </div>

                            <!-- 任务列表 -->
                            <div class="task-list">
                                <!-- 添加到桌面任务 -->
                                <div class="task-item">
                                    <div class="task-item-left">
                                        <img class="task-item-icon" src="/weryai_32.png" alt="微鲤AI" />
                                        <div class="task-item-info">
                                            <span class="task-item-name">{{ t('signIn.addToDesktop') }}</span>
                                            <span class="task-item-reward">+15 {{ t('signIn.tokens') }}</span>
                                        </div>
                                    </div>
                                    <!-- 未完成：显示"去完成" -->
                                    <button v-if="!addToDesktopRewards.added" class="task-item-btn"
                                        @click="handleAddToDesktop">{{
                                            t('signIn.goComplete') }}</button>
                                    <!-- 已完成且有待领取积分：显示"领取" -->
                                    <button v-else-if="addToDesktopRewards.pending_points > 0"
                                        class="task-item-btn task-item-btn-claim" :disabled="addToDesktopClaimLoading"
                                        @click="claimAddToDesktopRewards">{{ addToDesktopClaimLoading ?
                                            t('menus.claiming') : t('signIn.claimNow') }}</button>
                                    <!-- 已完成且已领取：显示"已完成" -->
                                    <button v-else class="task-item-btn task-item-btn-completed" disabled>{{
                                        t('signIn.completed') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 底部充值区域 - 贴着弹窗边框 -->
                    <div class="dialog-footer" @click="handleRechargeClick">
                        <div class="footer-left">
                            <span class="footer-text">{{
                                t('menus.rechargeForMoreCredits')
                                }}</span>
                            <img src="~/assets/images/common/arrow.svg" alt="arrow" class="footer-arrow" />
                        </div>
                        <img src="~/assets/images/common/integral_bg.svg" alt="bg" class="integral-bg" />
                        <div class="footer-right">
                            <img src="~/assets/images/common/coin.webp" alt="coin" class="footer-coin" />
                            <div class="coin-glow-wrapper">
                                <div class="coin-glow-outer"></div>
                                <div class="coin-glow-inner"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <!-- 移动端：Dialog弹窗 -->
            <el-dialog v-else v-model="dialogVisible" :show-close="false" :close-on-click-modal="true"
                :close-on-press-escape="true" :lock-scroll="false" width="90%" align-center
                class="sign-in-dialog-mobile" @close="handleDialogClose">
                <!-- 弹窗内容 -->
                <div class="dialog-wrapper-mobile">
                    <!-- 关闭按钮 -->
                    <button class="mobile-close-button" @click="handleDialogClose">
                        <svg class="w-[9px] h-[9px] text-white" viewBox="0 0 20 20" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>

                    <!-- 内容区域 -->
                    <div class="dialog-content-mobile">
                        <!-- 签到模块框 -->
                        <div class="sign-in-module-mobile">
                            <!-- 头部区域 -->
                            <div class="module-header-mobile">
                                <div class="header-top-mobile">
                                    <img src="~/assets/images/common/gift_.svg" alt="gift"
                                        class="header-gift-icon-mobile" />
                                    <div class="module-title-mobile" role="heading" aria-level="2">
                                        {{ t('menus.dailySignIn') }}
                                    </div>
                                </div>
                                <p class="module-subtitle-mobile">
                                    {{ t('menus.consecutiveSignInRewards') }}
                                </p>
                            </div>

                            <!-- Day 1-7 签到卡片 -->
                            <div class="sign-cards-grid-mobile">
                                <div v-for="(
reward, index
                                    ) in signCardData?.daily_rewards || []" :key="index" class="sign-card-mobile"
                                    :class="{
                                        'show-border':
                                            reward.sign_status === 'NOT_SIGN',
                                        'is-blindbox': !reward.visible,
                                        'not-open':
                                            reward.sign_status === 'NOT_OPEN',
                                    }">
                                    <!-- 签到奖励区域 -->
                                    <div class="sign-card-reward-mobile">
                                        <!-- 积分奖励 -->
                                        <template v-if="
                                            reward.visible &&
                                            reward.rewards?.length > 0
                                        ">
                                            <div class="reward-bg-mobile">
                                                <img src="~/assets/images/common/sign_in_bg.svg" alt="bg"
                                                    class="reward-bg-img-mobile" />
                                            </div>
                                            <div class="reward-content-mobile">
                                                <span class="reward-amount-mobile">+{{
                                                    reward.rewards?.[0]
                                                        ?.amount
                                                }}</span>
                                            </div>
                                        </template>
                                        <!-- 盲盒奖励 -->
                                        <template v-else-if="!reward.visible">
                                            <div class="blindbox-content-mobile">
                                                <img src="~/assets/images/common/big_prize.webp" alt="prize"
                                                    class="blindbox-icon-mobile" />
                                            </div>
                                        </template>
                                    </div>

                                    <!-- 底部信息 -->
                                    <div class="sign-card-footer-mobile">
                                        <!-- 已签到显示对勾图标 -->
                                        <img v-if="
                                            reward.sign_status === 'SIGNED'
                                        " src="~/assets/images/common/yes.svg" alt="signed"
                                            class="footer-yes-icon-mobile" />
                                        <!-- 未签到显示日期 -->
                                        <span v-else class="sign-card-day-mobile">
                                            {{ t('menus.day') }}
                                            {{ reward.day }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- 领取按钮 -->
                            <button class="claim-button-mobile" :class="{
                                disabled: todaySigned || claiming,
                            }" :disabled="todaySigned || claiming" @click="handleClaim">
                                {{ claimButtonText }}
                            </button>
                        </div>

                        <!-- 邀请好友模块 - 移动端 -->
                        <div class="invite-module-mobile">
                            <!-- 头部区域 -->
                            <div class="invite-header-mobile">
                                <div class="invite-header-left-mobile">
                                    <svg class="invite-icon-mobile" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M15 3H21V9" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M10 14L21 3" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span class="invite-title-mobile">{{ t('signIn.inviteFriends') }}</span>
                                </div>
                                <div class="invite-header-right-mobile">
                                    <span class="invite-limit-badge-mobile">{{ t('signIn.todayLimit') }}: {{
                                        inviteRewards.today_valid_count }}/10</span>
                                </div>
                            </div>

                            <!-- 链接复制区域 -->
                            <div class="invite-link-box-mobile">
                                <span class="invite-link-text-mobile">{{ inviteLink || 'weryai.com/?invite_code=...'
                                }}</span>
                                <button class="invite-copy-btn-mobile" @click="copyInviteLink">
                                    <svg class="copy-icon-mobile" width="12" height="12" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path
                                            d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span>{{ t('signIn.copyLink') }}</span>
                                </button>
                            </div>

                            <!-- 统计数据区域 -->
                            <div class="invite-stats-box-mobile">
                                <div class="invite-stat-item-mobile">
                                    <div class="stat-label-mobile">
                                        <svg class="stat-icon-mobile" width="12" height="12" viewBox="0 0 24 24"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                        <span>{{ t('signIn.validInvites') }}</span>
                                    </div>
                                    <div class="stat-value-row-mobile">
                                        <span class="stat-value-mobile">{{ inviteRewards.total_valid_count }}</span>
                                        <span class="stat-unit-mobile">{{ t('signIn.people') }}</span>
                                        <span class="stat-today-badge-mobile">{{ t('signIn.today') }}: {{
                                            inviteRewards.today_valid_count }}</span>
                                    </div>
                                </div>
                                <div class="invite-stat-divider-mobile"></div>
                                <div class="invite-stat-item-mobile">
                                    <div class="stat-label-mobile">
                                        <svg class="stat-icon-mobile" width="12" height="12" viewBox="0 0 24 24"
                                            fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20 12V22H4V12" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M22 7H2V12H22V7Z" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M12 22V7" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path
                                                d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                            <path
                                                d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z"
                                                stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                        <span>{{ t('signIn.pending') }}</span>
                                    </div>
                                    <div class="stat-value-row-mobile">
                                        <span class="stat-value-mobile tokens">{{ inviteRewards.pending_points }}</span>
                                        <span class="stat-unit-mobile tokens">{{ t('signIn.tokens') }}</span>
                                    </div>
                                </div>
                                <button class="invite-claim-btn-mobile"
                                    :disabled="claimLoading || inviteRewards.pending_points <= 0"
                                    @click="claimInviteRewards">
                                    {{ claimLoading ? '...' : t('signIn.claimNow') }}
                                </button>
                            </div>

                            <!-- 底部规则提示框 -->
                            <div class="invite-rules-box-mobile">
                                <div class="rules-left-mobile">
                                    <div class="rules-title-row-mobile">
                                        <span class="rules-title-mobile">{{ t('signIn.forEachFriend') }}</span>
                                        <span class="rules-hot-badge-mobile">HOT</span>
                                    </div>
                                    <div class="rules-content-mobile">
                                        <div class="rules-item-mobile">
                                            <svg class="rules-warn-icon-mobile" width="12" height="12"
                                                viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.29 3.86L1.82 18C1.64 18.3 1.55 18.64 1.55 19C1.55 19.36 1.64 19.7 1.82 20C2 20.3 2.26 20.56 2.56 20.74C2.86 20.92 3.2 21.01 3.55 21H20.49C20.84 21.01 21.18 20.92 21.48 20.74C21.78 20.56 22.04 20.3 22.22 20C22.4 19.7 22.49 19.36 22.49 19C22.49 18.64 22.4 18.3 22.22 18L13.75 3.86C13.57 3.56 13.31 3.32 13 3.15C12.69 2.98 12.35 2.89 12 2.89C11.65 2.89 11.31 2.98 11 3.15C10.69 3.32 10.43 3.56 10.25 3.86H10.29Z"
                                                    stroke="#FAAD14" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M12 9V13" stroke="#FAAD14" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <circle cx="12" cy="17" r="1" fill="#FAAD14" />
                                            </svg>
                                            <span class="rules-text-mobile">{{ t('signIn.ruleText') }} <span
                                                    class="rules-highlight-mobile">{{ t('signIn.completeGeneration')
                                                    }}</span> {{
                                                        t('signIn.afterReward') }}</span>
                                        </div>
                                        <div class="rules-item-mobile">
                                            <span class="rules-limit-mobile">{{ t('signIn.dailyLimitTip') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="rules-right-mobile">
                                    <span class="rules-reward-value-mobile">+35</span>
                                    <span class="rules-reward-unit-mobile">{{ t('signIn.tokens') }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 任务中心模块 -->
                        <div class="task-module-mobile">
                            <!-- 任务中心标题 -->
                            <div class="task-header-mobile">
                                <svg class="task-icon-mobile" width="14" height="14" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16 4H18C18.5304 4 19.0391 4.21071 19.4142 4.58579C19.7893 4.96086 20 5.46957 20 6V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H8"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M15 2H9C8.44772 2 8 2.44772 8 3V5C8 5.55228 8.44772 6 9 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 11H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 16H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 11H8.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8 16H8.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <span class="task-title-mobile">{{ t('signIn.taskCenter') }}</span>
                            </div>

                            <!-- 任务列表 -->
                            <div class="task-list-mobile">
                                <!-- 添加到桌面任务 -->
                                <div class="task-item-mobile">
                                    <div class="task-item-left-mobile">
                                        <img class="task-item-icon-mobile" src="/weryai_32.png" alt="微鲤AI" />
                                        <div class="task-item-info-mobile">
                                            <span class="task-item-name-mobile">{{ t('signIn.addToDesktop') }}</span>
                                            <span class="task-item-reward-mobile">+15 {{ t('signIn.tokens') }}</span>
                                        </div>
                                    </div>
                                    <!-- 未完成：显示"去完成" -->
                                    <button v-if="!addToDesktopRewards.added" class="task-item-btn-mobile"
                                        @click="handleAddToDesktop">{{ t('signIn.goComplete') }}</button>
                                    <!-- 已完成且有待领取积分：显示"领取" -->
                                    <button v-else-if="addToDesktopRewards.pending_points > 0"
                                        class="task-item-btn-mobile task-item-btn-claim-mobile"
                                        :disabled="addToDesktopClaimLoading" @click="claimAddToDesktopRewards">{{
                                            addToDesktopClaimLoading ? t('menus.claiming') :
                                                t('signIn.claimNow') }}</button>
                                    <!-- 已完成且已领取：显示"已完成" -->
                                    <button v-else class="task-item-btn-mobile task-item-btn-completed-mobile"
                                        disabled>{{
                                            t('signIn.completed') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 底部充值区域 - 贴着弹窗边框 -->
                    <div class="dialog-footer-mobile" @click="handleRechargeClick">
                        <div class="footer-left-mobile">
                            <span class="footer-text-mobile">{{
                                t('menus.rechargeForMoreCredits')
                                }}</span>
                        </div>
                        <img src="~/assets/images/common/integral_bg.svg" alt="bg" class="integral-bg-mobile" />
                        <div class="footer-right-mobile">
                            <img src="~/assets/images/common/coin.webp" alt="coin" class="footer-coin-mobile" />
                            <div class="coin-glow-wrapper-mobile">
                                <div class="coin-glow-outer-mobile"></div>
                                <div class="coin-glow-inner-mobile"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-dialog>

            <!-- PWA 引导弹窗 -->
            <ToolPwaGuideModal :visible="showPwaGuideModal" @close="closePwaGuideModal" />
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from '#imports'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import {
    getTodaySignStatusApi,
    getSignCardApi,
    everydaySignApi,
    getInviteCodeApi,
    getInviteRewardsApi,
    claimInviteRewardsApi,
} from '@/api/user'
import { emitOpenGoodsModal, emitter } from '@/utils/emitter'
import { useI18n } from '~/composables/useI18n'
import { showNotification } from '~/utils/common'
import { analyticsEvent } from '~/utils/log-event-func'

const { t } = useI18n()

// 类型定义
interface Reward {
    amount: number
    icon: string
    type: string
}

interface DailyReward {
    day: number
    rewards: Reward[]
    sign_status: 'NOT_SIGN' | 'SIGNED' | 'NOT_OPEN'
    visible: boolean
}

interface SignCardData {
    daily_rewards: DailyReward[]
    today_signed: boolean // 今日是否已签到
}

const userStore = useUserStore()
const route = useRoute()

// 检测是否为移动端
const isMobile = ref(false)

// 判断是否为首页（首页移动端使用 MobileHomeHeader 中的签到按钮）
const isHomePage = computed(() => {
    // 移除语言前缀后判断
    const path = route.path
    const cleanPath = path.replace(/^\/(zh|en|ja|ko|pt|es|de|fr|it|ru|hi|id|vi)(?=\/|$)/, '') || '/'
    return cleanPath === '/'
})

// 是否显示移动端悬浮按钮（首页不显示，因为有 MobileHomeHeader）
// const showMobileFloatButton = computed(() => isMobile.value && !isHomePage.value)

// 是否显示移动端悬浮按钮（现在所有页面都有 MobileHomeHeader 签到入口，不需要悬浮按钮了）
const showMobileFloatButton = computed(() => false)

const checkMobile = () => {
    if (import.meta.client) {
        isMobile.value = window.innerWidth < 768
    }
}

// 签到相关状态
const signStatus = ref<'NOT_SIGN' | 'SIGNED' | 'NOT_OPEN' | null>(null) // null表示还未获取状态
const lastCheckDate = ref<string>('') // 存储上次检查的UTC-0日期
const dialogVisible = ref(false) // 弹窗显示状态
const signCardData = ref<SignCardData | null>(null) // 签到卡片数据
const loading = ref(false) // 加载状态
const claiming = ref(false) // 签到中状态

// 邀请码相关状态
const inviteCode = ref<string>('') // 用户邀请码
const inviteRewardText = ref<string>('') // 邀请奖励文案
const inviteLoading = ref(false) // 邀请码加载状态

// 邀请奖励数据
const inviteRewards = ref({
    pending_points: 0,    // 待领取积分
    today_limit: 0,       // 今日邀请数上限
    today_valid_count: 0, // 今日有效邀请人数
    total_valid_count: 0  // 总有效邀请人数
})
const claimLoading = ref(false) // 领取奖励加载状态

// 添加到桌面奖励数据
const addToDesktopRewards = ref({
    added: false,        // 是否已完成任务
    pending_points: 0    // 待领取积分
})
const addToDesktopClaimLoading = ref(false) // 添加到桌面任务领取加载状态

// 生成的邀请链接
const inviteLink = computed(() => {
    if (!inviteCode.value) return ''
    const baseUrl =
        import.meta.client ? window.location.origin : 'https://www.weryai.com.cn'
    return `${baseUrl}/invitation?invite_code=${inviteCode.value}`
})

// 是否显示红点 - 只有接口返回 NOT_SIGN 才显示
const showRedDot = computed(() => signStatus.value === 'NOT_SIGN')

// 今日是否已签到 - 基于 signStatus 判断
const todaySigned = computed(() => signStatus.value === 'SIGNED')

// 领取按钮文案
const claimButtonText = computed(() => {
    if (claiming.value) return t('menus.claiming')
    if (todaySigned.value) return t('menus.claimed')
    return t('menus.claim')
})

// 获取签到状态
const fetchSignStatus = async () => {
    const userInfo = userStore.userInfo
    if (!userInfo) return

    // 获取当前UTC-0的日期
    const now = new Date()
    const currentUTCDate = now.toISOString().split('T')[0]

    // 如果今天已经检查过且已签到，不再调用接口
    if (
        lastCheckDate.value === currentUTCDate &&
        signStatus.value === 'SIGNED'
    ) {
        return
    }

    try {
        const res: any = await getTodaySignStatusApi()
        if (res?.data && res.data.sign_status) {
            signStatus.value = res.data.sign_status
            lastCheckDate.value = currentUTCDate || ''
        }
    } catch (error) {
        console.error('获取签到状态失败:', error)
    }
}

// 获取签到卡片数据
const fetchSignCardData = async () => {
    loading.value = true
    try {
        const res: any = await getSignCardApi()
        if (res?.data) {
            signCardData.value = res.data
        }
    } catch (error) {
        console.error('获取签到卡片数据失败:', error)
    } finally {
        loading.value = false
    }
}

// 获取用户邀请码
const fetchInviteCode = async () => {
    const userInfo = userStore.userInfo
    if (!userInfo) return

    inviteLoading.value = true
    try {
        const res: any = await getInviteCodeApi()
        if (res?.data) {
            inviteCode.value = res.data.invite_code || ''
            inviteRewardText.value = res.data.invited_reward_text || ''
        }
    } catch (error) {
        console.error('获取邀请码失败:', error)
    } finally {
        inviteLoading.value = false
    }
}

// 获取邀请奖励数据
const fetchInviteRewards = async () => {
    const userInfo = userStore.userInfo
    if (!userInfo) return

    try {
        const res: any = await getInviteRewardsApi('INVITE_REGISTER')
        if (res?.data?.invite_register_reward) {
            inviteRewards.value = res.data.invite_register_reward
        }
    } catch (error) {
        console.error('获取邀请奖励数据失败:', error)
    }
}

// 获取添加到桌面奖励数据
const fetchAddToDesktopRewards = async () => {
    const userInfo = userStore.userInfo
    if (!userInfo) return

    try {
        const res: any = await getInviteRewardsApi('ADD_TO_DESKTOP')
        if (res?.data?.add_to_desk_top_reward) {
            addToDesktopRewards.value = res.data.add_to_desk_top_reward
        }
    } catch (error) {
        console.error('获取添加到桌面奖励数据失败:', error)
    }
}

// 领取邀请奖励
const claimInviteRewards = async () => {
    if (inviteRewards.value.pending_points <= 0) {
        ElMessage.warning(t('signIn.noPendingRewards'))
        return
    }

    // 埋点：点击领取邀请奖励
    analyticsEvent('click_claim_invite_reward')

    claimLoading.value = true
    try {
        const res: any = await claimInviteRewardsApi('INVITE_REGISTER')
        if (res?.success || res?.code === 0) {
            showNotification.success(t('signIn.claimSuccess'))
            // 刷新奖励数据
            await fetchInviteRewards()
            // 刷新用户余额
            userStore.getBalance()
        } else {
            ElMessage.warning(res?.message || t('signIn.claimFailed'))
        }
    } catch (error) {
        ElMessage.error(t('signIn.claimFailed'))
    } finally {
        claimLoading.value = false
    }
}

// 领取添加到桌面奖励
const claimAddToDesktopRewards = async () => {
    if (addToDesktopRewards.value.pending_points <= 0) {
        ElMessage.warning(t('signIn.noPendingRewards'))
        return
    }

    addToDesktopClaimLoading.value = true
    try {
        const res: any = await claimInviteRewardsApi('ADD_TO_DESKTOP')
        if (res?.success || res?.code === 0) {
            showNotification.success(t('signIn.claimSuccess'))
            // 刷新奖励数据
            await fetchAddToDesktopRewards()
            // 刷新用户余额
            userStore.getBalance()
        } else {
            ElMessage.warning(res?.message || t('signIn.claimFailed'))
        }
    } catch (error) {
        ElMessage.error(t('signIn.claimFailed'))
    } finally {
        addToDesktopClaimLoading.value = false
    }
}

// 复制邀请链接和文案
const copyInviteLink = async () => {
    if (!inviteLink.value) {
        ElMessage.warning('邀请链接生成中，请稍后再试')
        return
    }

    // 埋点：点击复制邀请链接
    analyticsEvent('click_copy_invite_link')

    // 只复制邀请链接
    const copyText = inviteLink.value

    try {
        await navigator.clipboard.writeText(copyText)
        showNotification.success(t('signIn.copySuccess'))
    } catch (error) {
        // 降级方案：使用 execCommand
        const textArea = document.createElement('textarea')
        textArea.value = copyText
        textArea.style.position = 'fixed'
        textArea.style.left = '-9999px'
        document.body.appendChild(textArea)
        textArea.select()
        try {
            document.execCommand('copy')
            showNotification.success(t('signIn.copySuccess'))
        } catch (err) {
            ElMessage.error('复制失败，请手动复制')
        }
        document.body.removeChild(textArea)
    }
}

// 处理签到领取
const handleClaim = async () => {
    // 如果已签到或正在签到中，直接返回
    if (todaySigned.value || claiming.value) return

    // 找到当天需要签到的day
    const todayReward = signCardData.value?.daily_rewards?.find(
        reward => reward.sign_status === 'NOT_SIGN'
    )

    if (!todayReward) {
        ElMessage.warning(t('menus.noSignInAvailable'))
        return
    }

    claiming.value = true
    // 埋点：点击领取签到奖励
    analyticsEvent('click_claim_checkin_reward')
    try {
        const res: any = await everydaySignApi(todayReward.day)
        if (res?.code === 0 || res?.success) {
            // 签到成功
            ElMessage.success(t('menus.claimSuccess'))

            // 获取当前UTC-0的日期
            const now = new Date()
            const currentUTCDate = now.toISOString().split('T')[0]

            // 更新签到状态
            signStatus.value = 'SIGNED'
            lastCheckDate.value = currentUTCDate || ''

            // 刷新用户余额
            userStore.getBalance()

            // 重新获取签到卡片数据
            await fetchSignCardData()
        }
    } catch (error: any) {
        console.error('签到失败:', error)
        ElMessage.error(error?.message || t('menus.signInFailed'))
    } finally {
        claiming.value = false
    }
}

// 处理点击事件
const handleClick = () => {
    dialogVisible.value = true
}

// 监听弹窗打开，调用接口
watch(dialogVisible, newValue => {
    if (newValue) {
        // 埋点：看到签到弹窗
        analyticsEvent('view_checkin_popup')
        fetchSignCardData()
        fetchInviteCode()
        fetchInviteRewards()
        fetchAddToDesktopRewards()
    }
})

// 关闭弹窗
const handleDialogClose = () => {
    dialogVisible.value = false
}

// PWA 引导弹窗状态
const showPwaGuideModal = ref(false)

// 使用 PWA 提示状态管理（用于移动端底部抽屉）
const { pwaPromptVisible } = usePwaPrompt()

// 处理添加到桌面任务点击
const handleAddToDesktop = () => {
    // 埋点：点击去完成任务（使用任务类型作为 task_id）
    analyticsEvent('click_go_complete_task', {
        task_id: 'ADD_TO_DESKTOP'
    })

    dialogVisible.value = false  // 先关闭签到弹窗

    // 使用本组件的 isMobile 判断（与 UI 显示逻辑一致）
    if (isMobile.value) {
        // 移动端：显示底部抽屉
        pwaPromptVisible.value = true
        // 埋点：看到添加到桌面提示弹窗
        analyticsEvent('view_add_home_popup')
    } else {
        // PC端：打开引导弹窗
        showPwaGuideModal.value = true
        // 埋点：看到添加到桌面引导弹窗
        analyticsEvent('view_add_home_guide')
    }
}

// 关闭 PWA 引导弹窗
const closePwaGuideModal = () => {
    showPwaGuideModal.value = false
}

// 处理充值点击
const handleRechargeClick = () => {
    // 关闭签到弹窗
    dialogVisible.value = false
    // 拉起充值弹窗
    emitOpenGoodsModal()
}

// 打开签到弹窗（供外部调用）
const openSignInDialog = () => {
    dialogVisible.value = true
}

// 处理外部打开签到弹窗事件
const handleOpenSignInModal = () => {
    // 只有用户已登录才打开弹窗
    if (userStore.isLoggedIn) {
        openSignInDialog()
    }
}
// 监听全局签到弹窗事件

// 组件挂载时获取签到状态和检测移动端
onMounted(() => {
    fetchSignStatus()
    fetchSignCardData()
    checkMobile()
    if (import.meta.client) {
        window.addEventListener('resize', checkMobile)
        // 监听打开签到弹窗事件
        emitter.on('open-sign-in-modal', handleOpenSignInModal)
    }
})

// 组件卸载时移除监听器
onUnmounted(() => {
    if (import.meta.client) {
        window.removeEventListener('resize', checkMobile)
        // 移除签到弹窗事件监听
        emitter.off('open-sign-in-modal', handleOpenSignInModal)
    }
})

// 暴露方法供父组件调用
defineExpose({
    fetchSignStatus,
    openSignInDialog,
})
</script>

<style scoped lang="less">
.sign-in-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    cursor: pointer;
}

.sign-in-button {
    position: relative;
    min-width: 128px;
    width: fit-content;
    height: 35px;
    border-radius: 8px;
    /* 渐变背景 */
    background: linear-gradient(149deg,
            rgba(57, 58, 32, 1) 0%,
            rgba(35, 32, 27, 1) 0%,
            rgba(31, 28, 23, 1) 100%);
    /* 渐变边框实现 */
    border: 1px solid transparent;
    background-clip: padding-box;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 10px 0 10px;
    padding-right: 47px;
    transition: all 0.2s ease-in-out;

    /* 渐变边框效果 */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 8px;
        padding: 1px;
        background: linear-gradient(137deg,
                rgba(255, 254, 169, 0.4) 0%,
                rgba(163, 163, 163, 0) 100%);
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        pointer-events: none;
    }

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(253, 255, 181, 0.15);
    }

    &:active {
        transform: translateY(0);
    }
}

/* 全局图片样式 - 禁止选中 */
img {
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-drag: none;
    pointer-events: auto;
}

/* 签到领积分文字 */
.sign-in-text {
    font-family:
        'Source Han Sans CN',
        -apple-system,
        BlinkMacSystemFont,
        'Segoe UI',
        Roboto,
        sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 17px;
    /* 渐变文字颜色 */
    background: linear-gradient(130deg,
            rgba(253, 255, 181, 1) 0%,
            rgba(247, 204, 104, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    white-space: nowrap;
    flex-shrink: 0;
}

/* 小箭头图标 */
.sign-in-arrow {
    width: 12px;
    height: 12px;
    object-fit: contain;
    margin-left: 4px;
    flex-shrink: 0;
}

/* 签到图标 */
.sign-in-icon {
    position: absolute;
    right: 0;
    top: 1px;
    width: 37px;
    height: 33px;
    object-fit: contain;
}

/* 签到红点样式 */
.sign-red-dot {
    position: absolute;
    top: -1px;
    right: -2px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #de2c2c;
    border: 1px solid rgba(255, 255, 255, 0.4);
    z-index: 1;
}

/* ==================== 移动端悬浮按钮样式 ==================== */
/* 移动端签到按钮容器 - 固定在右下角 */
.sign-in-button-mobile-wrapper {
    position: fixed;
    bottom: 80px;
    right: 16px;
    z-index: 999;
    cursor: pointer;
}

.sign-in-button-mobile {
    position: relative;
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;

    &:active {
        transform: scale(0.95);
    }
}

.sign-in-phone-icon {
    width: 56px;
    height: 56px;
    object-fit: contain;
    filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15));
}

/* 移动端红点样式 */
.sign-red-dot-mobile {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #de2c2c;
    border: 1.5px solid rgba(255, 255, 255, 0.9);
    z-index: 1;
    animation: pulse 2s infinite;
}

/* 红点脉动动画 */
@keyframes pulse {

    0%,
    100% {
        transform: scale(1);
        opacity: 1;
    }

    50% {
        transform: scale(1.1);
        opacity: 0.8;
    }
}

/* ============ 弹窗样式 ============ */
.dialog-wrapper {
    position: relative;
    width: 722px;
    height: auto;
    min-height: 300px;
    max-height: 85vh;
    background: rgba(23, 20, 15, 1);
    border-radius: 20px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 右上角关闭按钮 */
.dialog-close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 34px;
    height: 34px;
    background: #00000060;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    transition: all 0.2s ease-in-out;

    &:hover {
        opacity: 0.8;
    }

    svg {
        width: 20px;
        height: 20px;
    }
}

/* 内容区域 */
.dialog-content {
    display: flex;
    flex-direction: column;
    padding: 24px;
    padding-bottom: 16px;
    position: relative;
    z-index: 3;
    flex: 1;
    gap: 16px;
    overflow-y: auto;
}

/* ============ 签到模块框 ============ */
.sign-in-module {
    background: rgba(252, 235, 211, 0.06);
    border: 1px solid transparent;
    border-radius: 14px;
    backdrop-filter: blur(20px);
    padding: 20px;
    position: relative;

    /* 渐变边框效果 */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 14px;
        padding: 1px;
        background: linear-gradient(137deg,
                rgba(255, 255, 255, 0.2) 0%,
                rgba(255, 255, 255, 0) 100%);
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        pointer-events: none;
    }
}

/* 模块头部区域 */
.module-header {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
}

.header-top {
    display: flex;
    align-items: flex-start;
    gap: 4px;
}

.header-gift-icon {
    width: 22px;
    height: 22px;
    margin-top: 4px;
}

.module-title {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 1.5em;
    margin: 0;
    background: linear-gradient(124deg,
            rgba(242, 223, 120, 1) 3%,
            rgba(236, 229, 192, 1) 54%,
            rgba(239, 198, 99, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.module-subtitle {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 1.5em;
    color: #ffffff;
    opacity: 0.6;
    margin: 0;
    padding-left: 0;
}

/* Day 1-7 签到卡片网格 */
.sign-cards-grid {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    margin-bottom: 16px;
}

/* 单个签到卡片 */
.sign-card {
    width: 82px;
    height: 104px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    padding: 12px;
    position: relative;
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;
    overflow: visible;

    /* 未签到状态显示渐变边框 */
    &.show-border {
        background: rgba(0, 0, 0, 0.2);
        border: 1px solid transparent;
        border-radius: 12px;
        background-clip: padding-box;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 12px;
            padding: 1px;
            background: linear-gradient(135deg,
                    rgba(254, 248, 146, 1) 0%,
                    rgba(255, 215, 95, 1) 100%);
            mask:
                linear-gradient(#fff 0 0) content-box,
                linear-gradient(#fff 0 0);
            mask-composite: exclude;
            -webkit-mask:
                linear-gradient(#fff 0 0) content-box,
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            pointer-events: none;
        }
    }

    /* 未开放状态 - 灰色 */
    &.not-open {
        .reward-bg::before {
            box-shadow: 0px 0px 8px 0px rgba(128, 128, 128, 0.3);
        }

        .reward-bg-img {
            filter: grayscale(100%);
            opacity: 0.5;
        }

        .reward-amount {
            color: #000000;
            opacity: 0.5;
        }
    }
}

/* 大奖角标 */
.prize-badge {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(136deg,
            rgba(254, 223, 98, 1) 0%,
            rgba(255, 236, 208, 1) 100%);
    border-radius: 0px 12px 0px 12px;
    padding: 4px 10px;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 1.5em;
    color: #b16a02;
    z-index: 2;
    white-space: nowrap;
    min-width: fit-content;
}

/* 签到奖励区域 */
.sign-card-reward {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

/* 积分背景 */
.reward-bg {
    position: absolute;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;

    /* 使用伪元素创建光晕效果 */
    &::before {
        content: '';
        position: absolute;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        box-shadow: 0px 0px 8px 0px rgba(255, 218, 6, 0.4);
        z-index: 0;
    }
}

.reward-bg-img {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
}

/* 奖励内容 - 积分 */
.reward-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.reward-amount {
    display: block;
    font-family: 'Arial', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.15em;
    color: #4a3100;
}

/* 盲盒内容 */
.blindbox-content {
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.blindbox-icon {
    width: 58px;
    height: 58px;
    object-fit: contain;
}

/* 底部信息 */
.sign-card-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

/* 已签到对勾图标 */
.footer-yes-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

/* Day 文字 - 居中 */
.sign-card-day {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 1.5em;
    color: #999999;
    text-align: center;
    width: 100%;
}

/* 未签到状态的 Day 文字 - 白色 */
.sign-card.show-border .sign-card-day {
    color: #ffffff;
}

/* 领取按钮 */
.claim-button {
    width: 100%;
    height: 44px;
    background: linear-gradient(90deg,
            rgba(255, 250, 149, 1) 0%,
            rgba(255, 215, 95, 1) 100%);
    border-radius: 10px;
    border: none;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 1.5em;
    color: #000000;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover:not(.disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 215, 95, 0.4);
    }

    &:active:not(.disabled) {
        transform: translateY(0);
    }

    /* 禁用状态 */
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background: linear-gradient(90deg,
                rgba(255, 250, 149, 0.5) 0%,
                rgba(255, 215, 95, 0.5) 100%);
    }
}

/* 底部充值区域 - 贴着弹窗边框 */
.dialog-footer {
    position: relative;
    width: 100%;
    height: 72px;
    background: linear-gradient(149deg,
            rgba(58, 53, 32, 1) 0%,
            rgba(35, 32, 27, 1) 0%,
            rgba(31, 28, 23, 1) 100%);
    border: none;
    border-radius: 0 0 20px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;

    /* 顶部分隔线 */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg,
                rgba(255, 254, 169, 0.3) 0%,
                rgba(255, 254, 169, 0.1) 50%,
                rgba(163, 163, 163, 0) 100%);
    }

    &:hover {
        background: linear-gradient(149deg,
                rgba(68, 63, 42, 1) 0%,
                rgba(45, 42, 37, 1) 0%,
                rgba(41, 38, 33, 1) 100%);
    }
}

/* 左侧：文字 + 箭头 + 背景图 */
.footer-left {
    display: flex;
    align-items: center;
    gap: 6px;
    position: relative;
    z-index: 1;
}

.footer-text {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 1.5em;
    background: linear-gradient(130deg,
            rgba(253, 255, 181, 1) 0%,
            rgba(247, 204, 104, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.footer-arrow {
    width: 12px;
    height: 12px;
}

/* 背景图 - 在左侧文字下方 */
.integral-bg {
    position: absolute;
    left: 0;
    height: 100%;
    width: auto;
    object-fit: contain;
}

/* 右侧：金币图标 + 光晕 */
.footer-right {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
}

.footer-coin {
    width: 32px;
    height: 32px;
    position: relative;
    z-index: 2;
}

/* 金币下方光晕效果容器 */
.coin-glow-wrapper {
    position: absolute;
    bottom: -3.7px;
    left: 50%;
    transform: translateX(-50%);
    width: 28.75px;
    height: 1.25px;
    z-index: 1;
}

/* 底层：棕色光晕 */
.coin-glow-outer {
    position: absolute;
    top: 0;
    left: 0;
    width: 28.75px;
    height: 1.25px;
    background: #ba995d;
    filter: blur(3px);
}

/* 顶层：亮黄色光晕 - 居中 */
.coin-glow-inner {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 11.53px;
    height: 1.25px;
    background: #feffd3;
    filter: blur(3px);
    opacity: 0.3;
}

/* ============ 邀请好友模块样式 ============ */
.invite-module {
    background: #1C1C20;
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 14px;
    padding: 20px;
    position: relative;
}

/* 邀请模块头部 */
.invite-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
}

.invite-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.invite-icon {
    color: #ffffff;
    opacity: 0.9;
}

.invite-title {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.5em;
    color: #FFF;
}

.invite-header-right {
    display: flex;
    align-items: center;
}

.invite-limit-badge {
    font-family: 'PingFang SC', 'Source Han Sans CN', sans-serif;
    font-size: 10px;
    font-weight: 600;
    color: #999;
    background: rgba(0, 0, 0, 0.40);
    border: 1px solid rgba(255, 255, 255, 0.05);
    padding: 4px 10px;
    border-radius: 5px;
}

/* 链接复制区域 */
.invite-link-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(0, 0, 0, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 12px;
}

.invite-link-text {
    font-family: 'SF Mono', 'Consolas', monospace;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
}

.invite-copy-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #242426;
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 8px 14px;
    color: #ffffff;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #2a2a2e;
        border-color: rgba(255, 255, 255, 0.1);
    }

    .copy-icon {
        width: 14px;
        height: 14px;
    }
}

/* 统计数据区域 */
.invite-stats-box {
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    padding: 16px 20px;
    margin-bottom: 12px;
}

.invite-stat-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.stat-label {
    display: flex;
    align-items: center;
    gap: 6px;
    color: rgba(255, 255, 255, 0.6);
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 13px;
}

.stat-icon {
    width: 14px;
    height: 14px;
    opacity: 0.6;
}

.stat-value-row {
    display: flex;
    align-items: baseline;
    gap: 4px;
}

.stat-value {
    font-family: 'DIN Alternate', 'Arial', sans-serif;
    font-weight: 700;
    font-size: 28px;
    color: #ffffff;

    &.tokens {
        color: #EAB308;
        font-size: 21px;
        font-weight: 900;
        line-height: 28px;
    }
}

.stat-unit {
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);

    &.tokens {
        color: rgba(202, 138, 4, 0.80);
        font-size: 10px;
        font-weight: 600;
    }
}

.stat-today-badge {
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.05);
    padding: 2px 8px;
    border-radius: 1.75px;
    margin-left: 8px;
}

.invite-stat-divider {
    width: 1px;
    height: 40px;
    background: rgba(255, 255, 255, 0.1);
    margin: 0 30px;
}

.invite-claim-btn {
    margin-left: auto;
    background: #EAB308;
    border: none;
    border-radius: 8px;
    padding: 12px 28px;
    color: #000;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 10px 15px -3px rgba(234, 179, 8, 0.10), 0 4px 6px -4px rgba(234, 179, 8, 0.10);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(234, 179, 8, 0.20), 0 4px 6px -4px rgba(234, 179, 8, 0.20);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
        background: linear-gradient(90deg, rgba(255, 250, 149, 0.5) 0%, rgba(255, 215, 95, 0.5) 100%);

        &:hover {
            transform: none;
            box-shadow: none;
        }
    }
}

/* 底部规则提示框 */
.invite-rules-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    background: linear-gradient(90deg, rgba(134, 48, 34, 0.40) 0%, rgba(139, 97, 29, 0.40) 100%);
    padding: 16px 20px;
}

.rules-left {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.rules-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.rules-title {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
}

.rules-hot-badge {
    color: #FFF;
    font-family: Inter;
    font-size: 9px;
    font-weight: 900;
    border-radius: 2px;
    background: linear-gradient(90deg, #F97316 0%, #DC2626 100%);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    padding: 2px 8px;
}

.rules-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.rules-item {
    display: flex;
    align-items: flex-start;
    gap: 6px;
}

.rules-warn-icon {
    flex-shrink: 0;
    margin-top: 2px;
}

.rules-text {
    color: rgba(233, 213, 255, 0.60);
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5em;
}

.rules-highlight {
    color: #FACC15;
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}

.rules-limit {
    color: rgba(255, 255, 255, 0.40);
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
}

.rules-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.50);
    box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.05) inset;
    padding: 12px 20px;
}

.rules-reward-value {
    color: #FACC15;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 900;
}

.rules-reward-unit {
    color: #854D0E;
    font-family: Inter;
    font-size: 9px;
    font-style: normal;
    font-weight: 900;
}

/* ============ 任务中心模块 ============ */
.task-module {
    background: #1C1C20;
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: 14px;
    padding: 20px;
}

.task-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
}

.task-icon {
    color: #FFF;
}

.task-title {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 700;
}

.task-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.task-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.10);
    padding: 14px 16px;
}

.task-item-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.task-item-icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
}

.task-item-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.task-item-name {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 13px;
    font-weight: 500;
}

.task-item-reward {
    color: #EAB308;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 600;
}

.task-item-btn {
    background: #242426;
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 8px 20px;
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #2a2a2e;
    }
}

.task-item-btn-claim {
    background: #A3E635;
    color: #000;
    border: none;

    &:hover {
        background: #84cc16;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.task-item-btn-completed {
    background: #3a3a3e;
    color: rgba(255, 255, 255, 0.5);
    border: none;
    cursor: not-allowed;
}

/* ==================== 移动端样式 ==================== */
/* 移动端弹窗容器 */
.dialog-wrapper-mobile {
    position: relative;
    width: 100%;
    min-width: 280px;
    height: auto;
    max-height: 85vh;
    background: rgba(23, 20, 15, 1);
    border-radius: clamp(8px, 2.5vw, 10px);
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 移动端关闭按钮 */
.mobile-close-button {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 21px;
    height: 21px;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid transparent;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    cursor: pointer;
    transition: all 0.2s ease;
    backdrop-filter: blur(12.35px);

    /* 渐变边框效果 */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: 50%;
        padding: 0.62px;
        background: linear-gradient(137deg,
                rgba(255, 255, 255, 0.2) 0%,
                rgba(255, 255, 255, 0) 100%);
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        pointer-events: none;
    }

    svg {
        width: 11.12px;
        height: 11.12px;
        position: relative;
        z-index: 1;
    }

    &:hover {
        opacity: 0.8;
    }

    &:active {
        transform: scale(0.9);
    }
}

/* 固定装饰元素容器 - 右上角，使用定位 */
.fixed-decorations-mobile {
    position: absolute;
    top: 0;
    right: 0;
    width: 152px;
    height: 152px;
    pointer-events: none;
    z-index: 2;
}

/* 光晕效果 - 右上角 */
.glow-effect-mobile {
    position: absolute;
    top: -19.5px;
    right: 0;
    width: 162px;
    height: 65.5px;
    background: #b69333;
    filter: blur(80px);
}

/* 右上角大礼物图标 */
.big-gift-icon-mobile {
    position: absolute;
    top: 0;
    right: 0;
    width: 132px;
    height: 132px;
}

/* 内容区域 */
.dialog-content-mobile {
    display: flex;
    flex-direction: column;
    padding: clamp(12px, 4vw, 15px);
    padding-bottom: clamp(10px, 3vw, 12px);
    position: relative;
    z-index: 3;
    flex: 1;
    gap: clamp(10px, 3vw, 12px);
    overflow-y: auto;
}

/* ============ 签到模块框 - 移动端 ============ */
.sign-in-module-mobile {
    background: rgba(252, 235, 211, 0.06);
    border: 1px solid transparent;
    border-radius: clamp(6px, 2vw, 7px);
    backdrop-filter: blur(10px);
    padding: clamp(10px, 3vw, 12px);
    position: relative;

    /* 渐变边框效果 */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: clamp(6px, 2vw, 7px);
        padding: 1px;
        background: linear-gradient(135deg,
                rgba(255, 255, 255, 0.2) 0%,
                rgba(255, 255, 255, 0.05) 50%,
                rgba(255, 255, 255, 0) 70%);
        mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        -webkit-mask:
            linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        pointer-events: none;
    }
}

/* 模块头部区域 - 移动端 */
.module-header-mobile {
    display: flex;
    flex-direction: column;
    margin-bottom: clamp(8px, 2.5vw, 10px);
}

.header-top-mobile {
    display: flex;
    align-items: flex-start;
    gap: clamp(1.5px, 0.5vw, 2px);
}

.header-gift-icon-mobile {
    width: clamp(14px, 4vw, 16px);
    height: clamp(14px, 4vw, 16px);
    margin-top: 2px;
}

.module-title-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: clamp(13px, 3.8vw, 15px);
    line-height: 1.5em;
    margin: 0;
    background: linear-gradient(124deg,
            rgba(242, 223, 120, 1) 3%,
            rgba(236, 229, 192, 1) 54%,
            rgba(239, 198, 99, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.module-subtitle-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: clamp(10px, 3vw, 12px);
    line-height: 1.5em;
    color: #ffffff;
    opacity: 0.6;
    margin: 0;
    padding-left: 0;
}

/* Day 1-7 签到卡片网格 */
.sign-cards-grid-mobile {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: clamp(3px, 1vw, 4px);
    margin-bottom: clamp(10px, 3vw, 12px);
}

/* 单个签到卡片 */
.sign-card-mobile {
    width: 100%;
    height: clamp(70px, 20vw, 82px);
    /* 响应式高度 */
    background: rgba(0, 0, 0, 0.3);
    border-radius: clamp(5px, 1.5vw, 6px);
    /* 响应式圆角 */
    display: flex;
    flex-direction: column;
    padding: clamp(5px, 1.5vw, 6px);
    /* 响应式内边距 */
    position: relative;
    transition: all 0.2s ease-in-out;
    border: 1px solid transparent;
    overflow: visible;

    /* 第7天占据两列宽度 */
    &:nth-child(7) {
        grid-column: span 2;
    }

    /* 未签到状态显示渐变边框 */
    &.show-border {
        background: rgba(0, 0, 0, 0.2);
        border: 1px solid transparent;
        border-radius: 6px;
        background-clip: padding-box;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 6px;
            padding: 0.75px;
            background: linear-gradient(135deg,
                    rgba(254, 248, 146, 1) 0%,
                    rgba(255, 215, 95, 1) 100%);
            mask:
                linear-gradient(#fff 0 0) content-box,
                linear-gradient(#fff 0 0);
            mask-composite: exclude;
            -webkit-mask:
                linear-gradient(#fff 0 0) content-box,
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: xor;
            pointer-events: none;
        }
    }

    /* 未开放状态 - 灰色 */
    &.not-open {
        .reward-bg-mobile::before {
            box-shadow: 0px 0px 8px 0px rgba(128, 128, 128, 0.3);
        }

        .reward-bg-img-mobile {
            filter: grayscale(100%);
            opacity: 0.5;
        }

        .reward-amount-mobile {
            color: #000000;
            opacity: 0.5;
        }
    }
}

/* 大奖角标 */
.prize-badge-mobile {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(136deg,
            rgba(254, 223, 98, 1) 0%,
            rgba(255, 236, 208, 1) 100%);
    border-radius: 0px clamp(5px, 1.5vw, 6px) 0px clamp(5px, 1.5vw, 6px);
    /* 响应式圆角 */
    padding: clamp(1.5px, 0.5vw, 2px) clamp(4px, 1.2vw, 5px);
    /* 响应式内边距 */
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: clamp(5px, 1.5vw, 6.5px);
    /* 响应式字体 */
    line-height: 1.5em;
    color: #b16a02;
    z-index: 2;
}

/* 签到奖励区域 */
.sign-card-reward-mobile {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

/* 积分背景 */
.reward-bg-mobile {
    position: absolute;
    width: 29px;
    height: 29px;
    display: flex;
    align-items: center;
    justify-content: center;

    /* 使用伪元素创建光晕效果 */
    &::before {
        content: '';
        position: absolute;
        width: 29px;
        height: 29px;
        border-radius: 50%;
        box-shadow: 0px 0px 8px 0px rgba(255, 218, 6, 0.4);
        z-index: 0;
    }
}

.reward-bg-img-mobile {
    width: clamp(26px, 7.5vw, 30px);
    /* 响应式宽度 */
    height: clamp(26px, 7.5vw, 30px);
    /* 响应式高度 */
    object-fit: contain;
    position: relative;
    z-index: 1;
}

/* 奖励内容 - 积分 */
.reward-content-mobile {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.reward-amount-mobile {
    display: block;
    font-family: 'Arial', sans-serif;
    font-weight: 700;
    font-size: clamp(9px, 2.6vw, 11px);
    /* 响应式字体 */
    line-height: 1.15em;
    color: #4a3100;
}

/* 盲盒内容 */
.blindbox-content-mobile {
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.blindbox-icon-mobile {
    width: 100%;
    height: 100%;
    /* 响应式高度 */
    object-fit: contain;
}

/* 底部信息 */
.sign-card-footer-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
}

/* 已签到对勾图标 */
.footer-yes-icon-mobile {
    width: 15px;
    height: 15px;
    flex-shrink: 0;
}

/* Day 文字 - 居中 */
.sign-card-day-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: clamp(8.5px, 2.4vw, 10px);
    /* 响应式字体 */
    line-height: 1.5em;
    color: #999999;
    text-align: center;
    width: 100%;
}

/* 未签到状态的 Day 文字 - 白色 */
.sign-card-mobile.show-border .sign-card-day-mobile {
    color: #ffffff;
}

/* 领取按钮 - 移动端 */
.claim-button-mobile {
    width: 100%;
    height: clamp(32px, 9vw, 38px);
    background: linear-gradient(90deg,
            rgba(255, 250, 149, 1) 0%,
            rgba(255, 215, 95, 1) 100%);
    border-radius: clamp(5px, 1.5vw, 6px);
    border: none;
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 500;
    font-size: clamp(12px, 3.5vw, 14px);
    line-height: 1.5em;
    color: #000000;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover:not(.disabled) {
        transform: translateY(-1px);
        box-shadow: 0 2px 6px rgba(255, 215, 95, 0.4);
    }

    &:active:not(.disabled) {
        transform: translateY(0);
    }

    /* 禁用状态 */
    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        background: linear-gradient(90deg,
                rgba(255, 250, 149, 0.5) 0%,
                rgba(255, 215, 95, 0.5) 100%);
    }
}

/* 底部充值区域 - 贴着弹窗边框 */
.dialog-footer-mobile {
    position: relative;
    width: 100%;
    height: clamp(50px, 14vw, 58px);
    background: linear-gradient(149deg,
            rgba(58, 53, 32, 1) 0%,
            rgba(35, 32, 27, 1) 0%,
            rgba(31, 28, 23, 1) 100%);
    border: none;
    border-radius: 0 0 clamp(8px, 2.5vw, 10px) clamp(8px, 2.5vw, 10px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 clamp(12px, 4vw, 16px);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;

    /* 顶部分隔线 */
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg,
                rgba(255, 254, 169, 0.3) 0%,
                rgba(255, 254, 169, 0.1) 50%,
                rgba(163, 163, 163, 0) 100%);
    }

    &:hover {
        background: linear-gradient(149deg,
                rgba(68, 63, 42, 1) 0%,
                rgba(45, 42, 37, 1) 0%,
                rgba(41, 38, 33, 1) 100%);
    }
}

/* 左侧：文字 + 箭头 + 背景图 */
.footer-left-mobile {
    display: flex;
    align-items: center;
    gap: clamp(2px, 0.8vw, 3px);
    /* 响应式间距 */
    position: relative;
    z-index: 1;
}

.footer-text-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 400;
    font-size: clamp(12px, 3.5vw, 14px);
    /* 响应式字体 */
    line-height: 1.5em;
    background: linear-gradient(130deg,
            rgba(253, 255, 181, 1) 0%,
            rgba(247, 204, 104, 1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.footer-arrow-mobile {
    width: clamp(5px, 1.5vw, 6.5px);
    /* 响应式宽度 */
    height: clamp(5px, 1.5vw, 6.5px);
    /* 响应式高度 */
}

/* 背景图 - 在左侧文字下方 */
.integral-bg-mobile {
    position: absolute;
    left: 0;
    height: 100%;
    width: auto;
    object-fit: contain;
}

/* 右侧：金币图标 + 光晕 */
.footer-right-mobile {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
}

.footer-coin-mobile {
    width: clamp(24px, 7vw, 28px);
    /* 响应式宽度 */
    height: clamp(24px, 7vw, 28px);
    /* 响应式高度 */
    position: relative;
    z-index: 2;
}

/* 金币下方光晕效果容器 - 和PC端一样的参数 */
.coin-glow-wrapper-mobile {
    position: absolute;
    bottom: -3.7px;
    /* 和PC端一样 */
    left: 50%;
    transform: translateX(-50%);
    width: 19px;
    /* 和PC端一样 */
    height: 0.8px;
    /* 和PC端一样 */
    z-index: 1;
}

/* 底层：棕色光晕 - 和PC端一样 */
.coin-glow-outer-mobile {
    position: absolute;
    top: 0;
    left: 0;
    width: 19px;
    /* 和PC端一样 */
    height: 0.8px;
    /* 和PC端一样 */
    background: #ba995d;
    filter: blur(3px);
    /* 和PC端一样 */
}

/* 顶层：亮黄色光晕 - 居中，和PC端一样 */
.coin-glow-inner-mobile {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0.8px;
    /* 和PC端一样 */
    height: 0.6px;
    /* 和PC端一样 */
    background: #feffd3;
    filter: blur(3px);
    /* 和PC端一样 */
    opacity: 0.3;
}

/* ============ 邀请好友模块样式 - 移动端 ============ */
.invite-module-mobile {
    background: #1C1C20;
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: clamp(6px, 2vw, 7px);
    padding: clamp(10px, 3vw, 12px);
    position: relative;
}

/* 邀请模块头部 - 移动端 */
.invite-header-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: clamp(10px, 3vw, 12px);
}

.invite-header-left-mobile {
    display: flex;
    align-items: center;
    gap: clamp(4px, 1.5vw, 6px);
}

.invite-icon-mobile {
    color: #ffffff;
    opacity: 0.9;
}

.invite-title-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 700;
    font-size: clamp(12px, 3.5vw, 14px);
    line-height: 1.5em;
    color: #FFF;
}

.invite-header-right-mobile {
    display: flex;
    align-items: center;
}

.invite-limit-badge-mobile {
    font-family: 'PingFang SC', 'Source Han Sans CN', sans-serif;
    font-size: clamp(9px, 2.5vw, 10px);
    font-weight: 600;
    color: #999;
    background: rgba(0, 0, 0, 0.40);
    border: 1px solid rgba(255, 255, 255, 0.05);
    padding: clamp(2px, 0.8vw, 3px) clamp(6px, 2vw, 8px);
    border-radius: 5px;
}

/* 链接复制区域 - 移动端 */
.invite-link-box-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    background: rgba(0, 0, 0, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: clamp(10px, 3vw, 12px);
    padding: clamp(10px, 3vw, 12px);
    margin-bottom: clamp(8px, 2.5vw, 10px);
}

.invite-link-text-mobile {
    font-family: 'SF Mono', 'Consolas', monospace;
    font-size: clamp(11px, 3vw, 12px);
    color: rgba(255, 255, 255, 0.7);
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.invite-copy-btn-mobile {
    display: flex;
    align-items: center;
    gap: clamp(3px, 1vw, 4px);
    background: #242426;
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: clamp(6px, 2vw, 8px);
    padding: clamp(5px, 1.5vw, 6px) clamp(8px, 2.5vw, 10px);
    color: #ffffff;
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: clamp(10px, 2.8vw, 11px);
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    white-space: nowrap;

    &:active {
        background: #2a2a2e;
    }

    .copy-icon-mobile {
        width: clamp(10px, 2.8vw, 12px);
        height: clamp(10px, 2.8vw, 12px);
    }
}

/* 统计数据区域 - 移动端 */
.invite-stats-box-mobile {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: clamp(8px, 2vw, 10px);
    background: rgba(0, 0, 0, 0.10);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: clamp(10px, 3vw, 12px);
    padding: clamp(10px, 3vw, 12px) clamp(12px, 3.5vw, 14px);
    margin-bottom: clamp(8px, 2.5vw, 10px);
}

.invite-stat-item-mobile {
    display: flex;
    flex-direction: column;
    gap: clamp(4px, 1.2vw, 6px);
}

.stat-label-mobile {
    display: flex;
    align-items: center;
    gap: clamp(3px, 1vw, 4px);
    color: rgba(255, 255, 255, 0.6);
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: clamp(10px, 2.8vw, 11px);
}

.stat-icon-mobile {
    opacity: 0.6;
}

.stat-value-row-mobile {
    display: flex;
    align-items: baseline;
    gap: clamp(2px, 0.8vw, 3px);
}

.stat-value-mobile {
    font-family: 'DIN Alternate', 'Arial', sans-serif;
    font-weight: 700;
    font-size: clamp(20px, 6vw, 24px);
    color: #ffffff;

    &.tokens {
        color: #EAB308;
        font-size: clamp(18px, 5.5vw, 21px);
        font-weight: 900;
        line-height: 28px;
    }
}

.stat-unit-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: clamp(11px, 3vw, 12px);
    color: rgba(255, 255, 255, 0.6);

    &.tokens {
        color: rgba(202, 138, 4, 0.80);
        font-size: clamp(9px, 2.5vw, 10px);
        font-weight: 600;
    }
}

.stat-today-badge-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-size: clamp(9px, 2.5vw, 10px);
    color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.05);
    padding: clamp(1px, 0.5vw, 2px) clamp(5px, 1.5vw, 6px);
    border-radius: 1.75px;
    margin-left: clamp(4px, 1.2vw, 6px);
}

.invite-stat-divider-mobile {
    width: 1px;
    height: clamp(28px, 8vw, 32px);
    background: rgba(255, 255, 255, 0.1);
    margin: 0 clamp(12px, 4vw, 16px);
}

.invite-claim-btn-mobile {
    width: 100%;
    background: #EAB308;
    border: none;
    border-radius: 8px;
    padding: clamp(10px, 3vw, 12px);
    color: #000;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 10px 15px -3px rgba(234, 179, 8, 0.10), 0 4px 6px -4px rgba(234, 179, 8, 0.10);

    &:active {
        transform: scale(0.98);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
        background: linear-gradient(90deg, rgba(255, 250, 149, 0.5) 0%, rgba(255, 215, 95, 0.5) 100%);

        &:active {
            transform: none;
        }
    }
}

/* 底部规则提示框 - 移动端 */
.invite-rules-box-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    background: linear-gradient(90deg, rgba(134, 48, 34, 0.40) 0%, rgba(139, 97, 29, 0.40) 100%);
    padding: clamp(10px, 3vw, 12px) clamp(12px, 3.5vw, 14px);
}

.rules-left-mobile {
    display: flex;
    flex-direction: column;
    gap: clamp(4px, 1.2vw, 6px);
    flex: 1;
}

.rules-title-row-mobile {
    display: flex;
    align-items: center;
    gap: clamp(4px, 1.2vw, 6px);
}

.rules-title-mobile {
    font-family: 'Source Han Sans CN', sans-serif;
    font-weight: 600;
    font-size: clamp(12px, 3.5vw, 13px);
    color: #ffffff;
}

.rules-hot-badge-mobile {
    color: #FFF;
    font-family: Inter;
    font-size: 9px;
    font-weight: 900;
    border-radius: 2px;
    background: linear-gradient(90deg, #F97316 0%, #DC2626 100%);
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    padding: clamp(1px, 0.4vw, 2px) clamp(5px, 1.5vw, 6px);
}

.rules-content-mobile {
    display: flex;
    flex-direction: column;
    gap: clamp(2px, 0.8vw, 3px);
}

.rules-item-mobile {
    display: flex;
    align-items: flex-start;
    gap: clamp(3px, 1vw, 4px);
}

.rules-warn-icon-mobile {
    flex-shrink: 0;
    margin-top: 1px;
}

.rules-text-mobile {
    color: rgba(233, 213, 255, 0.60);
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.4em;
}

.rules-highlight-mobile {
    color: #FACC15;
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    text-decoration: underline;
}

.rules-limit-mobile {
    color: rgba(255, 255, 255, 0.40);
    font-family: "PingFang SC";
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
}

.rules-right-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.50);
    box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.05) inset;
    padding: clamp(8px, 2.5vw, 10px) clamp(12px, 3.5vw, 14px);
    margin-left: clamp(8px, 2.5vw, 10px);
}

.rules-reward-value-mobile {
    color: #FACC15;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 900;
}

.rules-reward-unit-mobile {
    color: #854D0E;
    font-family: Inter;
    font-size: 9px;
    font-style: normal;
    font-weight: 900;
}

/* ============ 任务中心模块 - 移动端 ============ */
.task-module-mobile {
    background: #1C1C20;
    border: 1px solid rgba(255, 255, 255, 0.10);
    border-radius: clamp(10px, 3vw, 12px);
    padding: clamp(14px, 4vw, 16px);
}

.task-header-mobile {
    display: flex;
    align-items: center;
    gap: clamp(6px, 1.8vw, 8px);
    margin-bottom: clamp(12px, 3.5vw, 14px);
}

.task-icon-mobile {
    color: #FFF;
}

.task-title-mobile {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 700;
}

.task-list-mobile {
    display: flex;
    flex-direction: column;
    gap: clamp(8px, 2.5vw, 10px);
}

.task-item-mobile {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.10);
    padding: clamp(10px, 3vw, 12px) clamp(12px, 3.5vw, 14px);
}

.task-item-left-mobile {
    display: flex;
    align-items: center;
    gap: clamp(8px, 2.5vw, 10px);
    flex: 1;
    min-width: 0;
}

.task-item-icon-mobile {
    width: clamp(28px, 8vw, 32px);
    height: clamp(28px, 8vw, 32px);
    border-radius: 6px;
    flex-shrink: 0;
}

.task-item-info-mobile {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.task-item-name-mobile {
    color: #FFF;
    font-family: "PingFang SC";
    font-size: clamp(11px, 3vw, 12px);
    font-weight: 500;
}

.task-item-reward-mobile {
    color: #EAB308;
    font-family: "PingFang SC";
    font-size: clamp(10px, 2.8vw, 11px);
    font-weight: 600;
}

.task-item-btn-mobile {
    background: #242426;
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: clamp(6px, 2vw, 8px) clamp(12px, 3.5vw, 16px);
    color: #FFF;
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    flex-shrink: 0;

    &:active {
        background: #2a2a2e;
    }
}
</style>

<style lang="less">
/* 全局样式 - 覆盖 Element Plus Dialog */
.el-dialog.sign-in-dialog {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    border-radius: 20px !important;
    overflow: visible !important;

    .el-dialog__header {
        display: none !important;
        padding: 0 !important;
        margin: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
    }

    .el-dialog__body {
        padding: 0 !important;
        margin: 0 !important;
        background: transparent !important;
        overflow: visible !important;
    }

    .el-dialog__footer {
        display: none !important;
        padding: 0 !important;
        margin: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
    }
}

/* 遮罩层样式 */
.el-overlay {
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

/* 移动端弹窗全局样式 */
.el-dialog.sign-in-dialog-mobile {
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    border-radius: 10px !important;
    overflow: visible !important;

    .el-dialog__header {
        display: none !important;
        padding: 0 !important;
        margin: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
    }

    .el-dialog__body {
        padding: 0 !important;
        margin: 0 !important;
        background: transparent !important;
        overflow: visible !important;
    }

    .el-dialog__footer {
        display: none !important;
        padding: 0 !important;
        margin: 0 !important;
        height: 0 !important;
        min-height: 0 !important;
    }
}
</style>
